import { useLocation } from 'react-router-dom';

/**
 * Returns `lp(path)` — a helper that keeps in-site navigation within the active
 * language. Both languages are URL-prefixed: `/en/...` for English and
 * `/zh/...` for Chinese. It prefixes absolute internal paths accordingly and
 * leaves external / hash / non-string values untouched.
 *
 *   const lp = useLangLink();
 *   <Link to={lp('/banking-license')} />   // -> /en/banking-license or /zh/banking-license
 */
export default function useLangLink() {
    const { pathname } = useLocation();
    const onZh = pathname === '/zh' || pathname.startsWith('/zh/');
    const prefix = onZh ? '/zh' : '/en';
    return (p) => {
        if (!p || typeof p !== 'string' || p.charAt(0) !== '/') return p;
        return p === '/' ? prefix : `${prefix}${p}`;
    };
}
